import { FC } from 'react';
import { Link } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'config';
import { usePendingContentReviewForEntity } from 'store/admin-content-reviews';

export const ContentReviewPendingChip: FC<{ liveEntityId: string }> = ({
  liveEntityId,
}) => {
  const { t } = useTranslation();
  const { data: review } = usePendingContentReviewForEntity(liveEntityId);

  if (!review) {
    return null;
  }

  return (
    <Link
      label={t('contentReviews.pendingChip', {
        defaultValue: 'Pending review',
      })}
      to={ROUTES.admin.contentReviews.details.replace(':id', review.id)}
      typographyProps={{ color: 'warning' }}
    />
  );
};
